import React from 'react';

import { Tag } from '@/shared/components/ui/tag/tag';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';
import {
  ElidedPath,
  ElidedTagPath,
  GroupPathContainer,
} from '@/shared/features/groups/components/group-path/group-path.styled';
import { TGroupPathProps } from '@/shared/features/groups/components/group-path/group-path.types';
import { elideGroupPath } from '@/shared/features/groups/utils/group-path/elide-group-path';
import { useTextOverflow } from '@/shared/hooks/use-text-overflow/use-text-overflow';

export const GroupPath: React.FC<TGroupPathProps> = ({
  fullPath,
  variant = 'tag',
  onClick,
}) => {
  const { label, isElided } = elideGroupPath(fullPath);
  const { ref, isOverflowing } = useTextOverflow<HTMLSpanElement>(label);
  // An elided middle hides segments even where nothing is clipped.
  const tooltip = isElided || isOverflowing ? fullPath : '';

  if (variant === 'text') {
    return (
      <Tooltip title={tooltip} noMaxWidth>
        <ElidedPath ref={ref}>{label}</ElidedPath>
      </Tooltip>
    );
  }

  return (
    <GroupPathContainer>
      <Tooltip title={tooltip} noMaxWidth>
        <Tag
          label={<ElidedTagPath ref={ref}>{label}</ElidedTagPath>}
          onClick={onClick}
        />
      </Tooltip>
    </GroupPathContainer>
  );
};
